import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {IDropdownListItem} from './dropdown-list-item';

@Component({
    selector: 'db-dropdown-list',
    templateUrl: 'dropdown-list.component.html',
    styleUrls: ['dropdown-list.component.scss'],
    standalone: false
})
export class DropdownListComponent implements OnInit, AfterViewInit {

  @ViewChild('dropdownList') dropdownListRef: ElementRef;

  @Input() host: HTMLElement;
  @Input() position: 'top'|'bottom'|'left'|'right'|'custom'|'dropdown'|'right-with-gap'|'dropdown-payment-method';
  @Input() delay: number;
  @Input() className: string;
  @Input() items: Array<IDropdownListItem>;
  @Input() item?: any;
  @Output() cancelHideEvent = new EventEmitter<any>();

  public dropdownListStyle: any;

  @Input() public toggleOnHover: boolean;

  private top: any;
  private left: any;

  constructor(private $element: ElementRef) {
    this.dropdownListStyle = {};
  }

  ngOnInit() {}
  ngAfterViewInit() {
    const hostBoundingBox: ClientRect = this.host.getBoundingClientRect();
    const dropdownListBoundingBox: ClientRect = this.dropdownListRef.nativeElement.getBoundingClientRect();
    switch (this.position) {
      case 'top':
        this.top = hostBoundingBox.top - dropdownListBoundingBox.height;
        this.left = hostBoundingBox.left + hostBoundingBox.width / 2 - dropdownListBoundingBox.width / 2;
        break;

      case 'bottom':
        this.top = hostBoundingBox.bottom;
        this.left = hostBoundingBox.left + hostBoundingBox.width / 2 - dropdownListBoundingBox.width / 2;
        break;

      case 'left':
        this.top = hostBoundingBox.top + hostBoundingBox.height / 2 - dropdownListBoundingBox.height / 2;
        this.left = hostBoundingBox.left - dropdownListBoundingBox.width;
        break;

      case 'right':
        this.top = hostBoundingBox.top + hostBoundingBox.height / 2 - dropdownListBoundingBox.height / 2;
        this.left = hostBoundingBox.right;
        break;

      case 'custom':
        this.top = hostBoundingBox.top;
        this.left = hostBoundingBox.left;
        break;

      case 'dropdown':
        this.top = hostBoundingBox.bottom - 9 - 5;
        if (hostBoundingBox.bottom + 71 > window.innerHeight) {
          this.top = hostBoundingBox.bottom - 71;
        }
        this.left = hostBoundingBox.left + hostBoundingBox.width  - dropdownListBoundingBox.width;
        break;

      case 'dropdown-payment-method':
        this.top = hostBoundingBox.bottom - 9;
        if (hostBoundingBox.bottom + 98 > window.innerHeight) {
          this.top = hostBoundingBox.bottom - 98;
        }
        this.left = hostBoundingBox.left + hostBoundingBox.width  - dropdownListBoundingBox.width + 13;
        break;

      case 'right-with-gap':
        this.top = hostBoundingBox.bottom - 9;
        this.left = hostBoundingBox.left + hostBoundingBox.width  - dropdownListBoundingBox.width + 20;
        break;

    }

    setTimeout((): void => {
      this.dropdownListStyle = {
        top: this.top + 'px',
        left: this.left + 'px'
      };
    }, this.delay || 0);
  }


  public onMouseEnter(): void {
    this.cancelHideEvent.emit('show');
  }

  public onMouseLeave(): void {
    this.cancelHideEvent.emit('hide');
  }


  public onItemClick($event: Event, item: IDropdownListItem) {
    if (this.item) {
      item.action(this.item);
    }
    else {
      item.action();
    }
  }

}
